import { useMutation, useQueryClient } from '@tanstack/react-query';
import { login, sendOtp, verifyOtp, resetPassword } from '../service/auth';
import { Auth } from '../types/profile';

export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Auth) => login(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });
};

export const useSendOTP = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { email: string; captchaToken: string; website?: string }) =>
      sendOtp(data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sendOtp'] });
    },
  });
};

export const useVerifyOTP = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { email: string; otp: string }) => verifyOtp(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['verifyOtp'] });
    },
  });
};

export const useResetPassword = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { token: string; newPassword: string }) =>
      resetPassword(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['resetPassword'] });
    },
  });
};
